import React from 'react';
import AUX from '../../../hoc/AU-X/AU-X';
// import logo from '../../../assets/logo.png';
import './Footer.scss';

const Footer = () => {
  return (
    <AUX>
      <div className='upperFooter'>
        <p>شرکت مهندسین مشاور آب و محیط زیست پایدار شریف</p>
        <p>پل های ارتباطی</p>
      </div>
      <div className='lowerFooter'>
        <div>
          <div>
            <p>طراحی و بهینه سازی سایت : با شرکت ست پلت</p>
            <p>(کلیه حقوق نزد مهندسین مشاور آب و محیط زیست پایدار شریف محفوظ است.)</p>
          </div>
        </div>

        {/* <img src={logo} alt='logo' title='logo' /> */}

        <div>
          <ul>
            <li>نشانی: تهران، بلوار تیموری، خیابان لطفعلی خانی، خیابان پارس، پلاک 15، واحد 6</li>
            <li>شماره تماس: 66513443</li>
            <li>کد پستی: 1459853397</li>
            <li>EMAIL: info@abopa.ir</li>
          </ul>
        </div>
      </div>
    </AUX>
  );
};

export default Footer;
